<template>
  <form @submit.stop.prevent="validate">
    <InputBig
      autofocus
      type=tel
      mask=phone
      name=phone
      class="mb-9 mb-md-12"

      :label="$bimTranslate('form.phoneNumber', activeLang)"
      :placeholder="$bimTranslate('form.phone', activeLang)"

      v-model="form.phone"
      @keypress.enter="$emit('submit')"

      :formModel="_self"
      formKey="form.phone"
    />

    <div class="info-block">
      <div class="info-block__image mb-6" v-html="require('@/assets/img/lock-info.svg')"></div>

      <bimCheckbox
        class="agreement mb-6"
        v-model="agreement"
      >
      <span>
        Направляя свои персональные данные, я даю
        <a
          href="https://bimlib.pro/agreement/"
          target="_blank"
          class="info-block__link"
        >
          согласие
        </a>
        на их обработку
      </span>
      </bimCheckbox>
    </div>

    <TextValid v-if="$v2.validForm && form.email">{{ $bimTranslate('form.readyToSend', activeLang) }}</TextValid>
    <TextValid v-if="!$v2.validForm">{{ $bimTranslate('form.enterPhoneNumber', activeLang) }}</TextValid>

    <ButtonBig
      class="mt-6"
      :disabled="!$v2.validForm || !agreement"
      :label="$bimTranslate('form.next', activeLang)"
      type="submit"
    />
  </form>
</template>

<script>
import bimCheckbox from '@/components/form/bimCheckbox/bimCheckbox'

import ButtonBig from './ButtonBig.vue'
import InputBig from './InputBig.vue'
import TextValid from './TextValid.vue'

import stepMixin from './step.mixin'

export default {
  name: 'StepPhoneNumber',
  mixins: [stepMixin],
  inject: ['activeLang'],
  components: {
    bimCheckbox,
    ButtonBig,
    InputBig,
    TextValid
  },
  data: () => ({
    agreement: false,
  }),
  computed: {
    formValidation () {
      return {
        'form.phone': ['required', 'phone']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-block {
  text-align: center;
  margin-bottom: 4.6667rem;

  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    margin-bottom: 2.6667rem;
  }

  .info-block__link {
    transition: color .2s;
    text-decoration: none;
    color: inherit;
    border-bottom: 1px dashed $primary-color;

    &:hover {
      color: $primary-color;
    }
  }

  .info-block__image {
    display: inline-block;

    ::v-deep svg {
      width: 50px;
      height: 50px;
    }
  }
}

.agreement {
  font-size: 14px;

  a {
    color: #00afa1;
  }
}
</style>
